import React from "react";
import { ExpandedDescriptionTextSection } from "~/ProductDetails/ProductDetailPageResult";
import Section from "./Section";
interface Props {
  sections: ExpandedDescriptionTextSection[];
}
const ContentTextImageDouble = ({
  sections
}: Props) => <>
    {sections && sections.length === 2 && <div className="detail-section textimage-highlight-template box-border lt:px-6" data-testid="content-image-text-double">
        <div className="flex-container justify-center">
          <div className="highlight-2 xs:gap-5 sm:flex-auto xs:flex px-5 lt:px-0 xs:py-4">
            {sections && sections.length === 2 && sections.map(section => <div className="highlight-item xl:mx-0 px-0 mb-0 flex xs:items-center" key={section.headline}>
                  <Section section={section} isDoubleLayout videoClassNames="mx-auto xs:mx-0 my-0" />
                </div>)}
          </div>
        </div>
      </div>}
  </>;
export default ContentTextImageDouble;